import React from 'react'
import Grid from '@material-ui/core/Grid'

import Warranty from "../../../../components/Products/Usermanuals/Warranty/warranty"
import Company from "../../../../components/Products/Usermanuals/Warranty/company-card"
import Hotline from "../../../../components/Products/Usermanuals/Warranty/hotline-card"
import LicenseDisposal from "../../../../components/Products/Usermanuals/Warranty/license-disposal"

import SEOHelmet from '../../../../components/Layout/SEOHelmet'
import Footer from '../../../../components/Layout/footer/'
import BreadCrumbs from '../../../../components/Layout/breadcrumbs/breadcrumbs'

const seodata = {
  title: 'INSTAR IN-8001 Full HD Warranty & Disposal',
  description: 'The IN-8001 Full HDs compact design of this camera was completely new developed and makes it ideal for discreet surveillance task. The 6-times 940nm night vision LEDs are invisible to the human eye, making the IN-8001 a suitable baby monitor.',
  image: '/images/Search/P_SearchThumb_IN-8001HD_Warranty.png'
}

export default (props) => (
  <React.Fragment>
    <SEOHelmet title={seodata.title} description={seodata.description} image={seodata.image} location={props.location.pathname} />
      <h1 id="introduction" style={{ marginTop: 0 }}>
        IN-8001 Full HD Warranty & Disposal
    </h1>

      <BreadCrumbs
        pills={
          [
            {
              pill: "Indoor Cameras",
              link: "/fr/Indoor_Cameras/"
            },
            {
              pill: "Usermanual",
              link: "/fr/Indoor_Cameras/IN-8001_HD/Usermanual/"
            },
            {
              pill: "Overview",
              link: "/fr/Indoor_Cameras/IN-8001_HD/"
            },
            {
              pill: "Warranty",
              link: "/fr/Indoor_Cameras/IN-8001_HD/Warranty/"
            },
          ]
        } />

      <Warranty />
      <br />
      <br />
      <Grid container spacing={10}>
        <Grid item xs={12} sm={6}>
          <Company />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Hotline />
        </Grid>
      </Grid>
      <br />
      <br />
      <LicenseDisposal />
      <br />
      <br />
      <Footer
        previousTitle="Overview"
        previousLink="/fr/Indoor_Cameras/IN-8001_HD/"
        nextTitle="Safety Warnings"
        nextLink="/fr/Indoor_Cameras/IN-8001_HD/Safety_Warnings/" />
    </React.Fragment>
    )